@if (cell$ | async; as cell) {
  <span>
    @switch (cell.type) {
      @case (CellType.TEXT) {
        <div [innerHTML]="replaceLineSeparator(cell.content)"></div>
      }
      @case (CellType.IMAGE) {
        <img class="order-item-image" [src]="cell.content" (error)="onPreviewLoadError($event)" />
      }
    }
  </span>
}
